import { MetricPairTypeId as MetricPairTypeId$1, make as make$1, unsafeMake as unsafeMake$1 } from '../../internal/metric/pair.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricPairTypeId = MetricPairTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = unsafeMake$1;

export { MetricPairTypeId, make, unsafeMake };
